module.exports = __webpack_public_path__ + "static/image/logo-family/logo_connect@3x.png?d94b4c05";